const CreditsProgressBar = ({ spent = 0, limit = 0, handleShowSettings }) => {
  // const spentPercentage = Math.min((spent / limit) * 100, 100);
  // const percentage = 100 - spentPercentage;
  // // Choose color based on percentage
  // let progressColor = '#f7374f';
  // if (percentage > 80) {
  //   progressColor = '#42b966'; // Green
  // } else if (percentage > 50) {
  //   progressColor = '#feba17'; // Yellow
  // } else {
  //   progressColor = '#f7374f'; // Red
  // }
  const spentPercentage = Math.min((spent / limit) * 100, 100);

  // Choose color based on spent percentage
  let progressColor = '#f7374f'; // Default Red
  if (spentPercentage <= 35) {
    progressColor = '#42b966'; // Green
  } else if (spentPercentage <= 70) {
    progressColor = '#feba17'; // Yellow
  } else {
    progressColor = '#f7374f'; // Red
  }


  return (
    <div className="credit-usage-wrapper mb-3 text-disapper">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="credit-usage-label mb-0"
          >Credit usage</span>
        {/* <button className="btn common-btn"  disabled style={{ padding: "2px 4px", borderRadius: "4px" }}  onClick={()=>{handleShowSettings("step2")}}>Upgrade</button> */}
      </div>
      <div className="d-flex justify-content-between mb-1">
        <span className="credit-usage-value">
          Spent <strong>{spent}</strong>
        </span>
        <span className="credit-usage-value">
          Limit <strong>{limit}</strong>
        </span>
      </div>
      <div className="credit-usage progress progress-custom-bg d-flex align-items-center">
        <div
          className="credit-usage progress-bar"
          role="progressbar"
          style={{
            width: `${spentPercentage}%`,
            backgroundColor: progressColor,
            borderRadius: "4px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default CreditsProgressBar;
